// theme.js
import { extendTheme } from '@chakra-ui/react';

export const theme = extendTheme({
  colors: {
    // black: {
    //   500: '#000', // you need this
    // },
    gray: {
      300: '#fff',
      500: '#ccc',
      600: '#f0f0f0',
    },
    // mylight: {
    //   50: '#f0f0f0',
    //   100: '#f0f0f0',
    //   200: '#f0f0f0',
    //   300: '#ffffff',
    //   400: '#ffffff',
    //   500: '#ffffff',
    //   600: '#f5f5f5',
    //   700: '#f5f5f5',
    //   800: '#fafafa',
    //   900: '#fafafa',
    // },
    // myDark: {
    //   50: '#101010',
    //   100: '#101010',
    //   200: '#101010',
    //   300: '#101010',
    //   400: '#101010',
    //   500: '#101010',
    //   600: '#101010',
    //   700: '#101010',
    //   800: '#101010',
    //   900: '#101010',
    // },
  },
  // shadows: {
  //   outline: '0 0 0 2px #000000',
  // },
  shadows: {
    outline: '0 0 2px 0 rgba(17, 17, 17, 0.5)',
  },
  components: {
    Input: {
      // style object for base or default style
      baseStyle: {
        // focusBorderColor: 'black.500',
      },
      // styles for different sizes ("sm", "md", "lg")
      sizes: {},
      // styles for different visual variants ("outline", "solid")
      variants: {
        myinput: {
          // Note that Input compoennt has `field` and `addon`
          // which needs to be configured seperately to work
          field: {
            fontSize: '18px',
            fontWeight: '400',
            border: 'solid 1px #eee;',
            height: '44px',
            _placeholder: { color: '#ccc' },
            _focus: {
              boxShadow: 'outline',
              border: 'solid 1px #111',
            },
          },
        },
      },
      defaultProps: {},
    },
    // Button: {
    //   // 4. We can override existing variants
    //   solid: (props: any) => ({
    //     bg: props.colorMode === 'light' ? 'mylight.300' : 'myDark.500',
    //   }),
    //   // style object for base or default style
    //   baseStyle: {},
    //   // styles for different sizes ("sm", "md", "lg")
    //   sizes: {},
    //   // styles for different visual variants ("outline", "solid")
    //   variants: {
    //     primary: {
    //       bg: 'black',
    //       color: '#fff',
    //       width: '100%',
    //       height: '44px',
    //       fontWeight: '400',
    //       borderRadius: '3px',
    //       fontSize: '19px',
    //       letterSpacing: '0.3px',
    //       _focus: {
    //         boxShadow: 'none',
    //       },
    //     },
    //     menuBtn: {
    //       bg: '#fff',
    //       height: '44px',
    //       fontWeight: '400',
    //       fontSize: '19px',
    //       border: 'solid 1px #eee;',
    //       color: '#ccc',
    //       _active: {
    //         boxShadow: 'outline',
    //       },
    //       _focus: {
    //         boxShadow: 'outline',
    //       },
    //     },
    //     infoMenuBtn: {
    //       bg: 'grey.600',
    //       fontWeight: '400',
    //       fontSize: '19px',
    //       _active: {
    //         boxShadow: 'none',
    //       },
    //       _focus: {
    //         boxShadow: 'outline',
    //       },
    //     },
    //   },
    // },
  },
});
